module.exports = __webpack_public_path__ + "Icon_Safer systems@2x.png?425bde0d5a3dcc6a2effdc31e56650f9";